import Reveal from "./Reveal";

export default function SectionHeading({ overline, title, children, dark = false, testId }) {
    return (
        <Reveal className="max-w-3xl">
            <p className={`text-xs font-semibold uppercase tracking-[0.28em] ${dark ? "text-gold" : "text-terracotta"}`}>
                {overline}
            </p>
            <h2
                data-testid={testId}
                className={`mt-4 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl ${dark ? "text-cream" : "text-ink"}`}
            >
                {title}
            </h2>
            {children && (
                <p className={`mt-5 text-sm leading-relaxed md:text-base ${dark ? "text-cream/75" : "text-moss"}`}>
                    {children}
                </p>
            )}
        </Reveal>
    );
}
